/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectrevenueDto } from '../models/work-create-projectrevenue-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProject } from '../models/work-project';
import { WorkProjectrevenue } from '../models/work-projectrevenue';

@Injectable({ providedIn: 'root' })
export class WorkProjectrevenuesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectrevenuesV2ControllerFindAllPaginated()` */
  static readonly ProjectrevenuesV2ControllerFindAllPaginatedPath = '/v2/Projectrevenues/findAllForProjectId/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectrevenuesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectrevenuesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> createdBy:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectrevenue>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectrevenuesV2Service.ProjectrevenuesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProjectrevenue>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'projectId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectrevenuesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectrevenuesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> createdBy:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectrevenue>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}> {
    return this.projectrevenuesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectrevenue>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProjectrevenue>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectrevenuesV2ControllerCreate()` */
  static readonly ProjectrevenuesV2ControllerCreatePath = '/v2/Projectrevenues';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectrevenuesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectrevenuesV2ControllerCreate$Response(
    params: {
      body: WorkCreateProjectrevenueDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectrevenuesV2Service.ProjectrevenuesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectrevenuesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectrevenuesV2ControllerCreate(
    params: {
      body: WorkCreateProjectrevenueDto
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectrevenuesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

}
